import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { styleConstant } from "../../Constants";

export const useStyles = makeStyles((theme: Theme) => {
  const { siteNavigationComponentHeight } = styleConstant;

  return createStyles({
    contactDetail_root: {
      gridColumnStart: "center",
      gridRowStart: "top",
      gridRowEnd: "bottom",
      zIndex: 0,
      height: "100%"
    },
    content: {
      paddingTop: siteNavigationComponentHeight,
      height: "100%",
      paddingLeft: "50px"
    }
  });
});
